import { render } from "./AutoResizeTextarea.vue?vue&type=template&id=2b37690a&scoped=true&ts=true"
import script from "./AutoResizeTextarea.vue?vue&type=script&lang=ts"
export * from "./AutoResizeTextarea.vue?vue&type=script&lang=ts"

import "./AutoResizeTextarea.vue?vue&type=style&index=0&id=2b37690a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b37690a"]])

export default __exports__